"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSchemaProperties = exports.AccountSchema = exports.SectionTitlesSchema = exports.AccountPublicItemType = exports.AccountIntegrations = void 0;
const zod_1 = require("zod");
const Email_1 = require("../utils/Email");
const account_integrations_1 = require("./account-integrations");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.AccountIntegrations = zod_1.z.object({
    calendar: zod_1.z.array(zod_1.z.object({
        gcal: zod_1.z.any(),
        gcalServerToken: zod_1.z.any(),
    })),
    email: zod_1.z.array(zod_1.z.object({
        gcal: zod_1.z.any(),
        gcalServerToken: zod_1.z.any(),
    })),
});
exports.AccountPublicItemType = zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), publicOrder: zod_1.z.number().optional() }));
exports.SectionTitlesSchema = zod_1.z.object({
    packages: zod_1.z.string().optional(),
    schedulers: zod_1.z.string().optional(),
    members: zod_1.z.string().optional(),
});
exports.AccountSchema = base_schema_1.BaseSchema.extend({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    email: Email_1.emailZodSchema,
    avatarURL: zod_1.z.string().nullable().optional(),
    integrations: account_integrations_1.AccountIntegrationsSchema.optional(),
    timeZone: zod_1.z.string().optional(),
    gcal: account_integrations_1.GcalSchema.optional(),
    gcalServerToken: zod_1.z.any().optional(),
    zoom: zod_1.z.any().optional(),
    secret: zod_1.z.boolean().optional(),
    publicOrder: zod_1.z.number().optional().nullable(),
    title: zod_1.z.string().optional(),
    memberSchedulers: exports.AccountPublicItemType.optional(),
    memberPackages: exports.AccountPublicItemType.optional(),
    slug: zod_1.z.string().optional(),
    bio: zod_1.z.string().optional(),
    coachLocation: zod_1.z.string().optional(),
    website: zod_1.z.string().optional(),
    sectionTitles: exports.SectionTitlesSchema.optional(),
    socialLinks: zod_1.z
        .object({
        linkedin: zod_1.z.string(),
        instagram: zod_1.z.string(),
        twitter: zod_1.z.string(),
    })
        .optional(),
    onboarding: zod_1.z.any().optional(),
});
exports.AccountSchemaProperties = {
    collectionName: "accounts",
    deleteMode: schema_properties_interface_1.DeleteMode.InStatus,
};
//# sourceMappingURL=account-schema.js.map